var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.5907 57.5906C75.9347 39.2467 85.3486 18.9192 78.6173 12.1879C71.8861 5.45667 51.5586 14.8706 33.2146 33.2145C14.8707 51.5585 5.45677 71.886 12.188 78.6172C18.9193 85.3485 39.2468 75.9346 57.5907 57.5906Z",
    fill: "#9847F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6173 78.6173C85.3486 71.886 75.9347 51.5585 57.5907 33.2145C39.2468 14.8706 18.9193 5.45668 12.188 12.1879C5.45676 18.9192 14.8707 39.2467 33.2146 57.5906C51.5586 75.9346 71.8861 85.3485 78.6173 78.6173Z",
    fill: "#9847F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/Feedback.20e9dc06c847ce5e483591ab4d4a44bd.svg";
export { ForwardRef as ReactComponent };